import React, { useState } from 'react'
import DesignationList from './DesignationList'
import DesignationForm from './DesignationForm';

const Designation= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <DesignationForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <DesignationList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default Designation;